import { graphql } from "react-relay";
import "./OnboardingNUX.gql";

export const fragments = {
  org: graphql`
    fragment OnboardingNUXRenderer_org on Org {
      id
      experiments
      primaryOrgCalendar
    }
  `,
};

export const query = graphql`
  query OnboardingNUXRendererQuery(
    $orgRelayId: ID!
    $timeZone: String!
    $week: LocalWeek!
    $myCalendarIds: [String!]!
  ) {
    viewer {
      ...OnboardingNUX_viewer
        @arguments(
          orgRelayId: $orgRelayId
          timeZone: $timeZone
          week: $week
          myCalendarIds: $myCalendarIds
        )
    }
  }
`;
